module.exports = __webpack_public_path__ + "static/media/3.7e1e7a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/3.png
// module id = 762
// module chunks = 0